import { BrowserRouter, HashRouter, Route } from 'react-router-dom';
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AnimatedRoutes } from "@/components/AnimatedRoutes";
import { PageTransition } from "@/components/PageTransition";
import Navbar from "@/components/Navbar";
import MusicPlayer from "@/components/MusicPlayer";
import GhibliBackground from "@/components/GhibliBackground";
import PasswordGate from "@/components/PasswordGate";
import Home from "./pages/Home";
import MapPage from "./pages/MapPage";
import TimelinePage from "./pages/TimelinePage";
import PhotosPage from "./pages/PhotosPage";
import AboutPage from "./pages/AboutPage";
import NotFound from "./pages/NotFound";

// 检测是否使用 HashRouter（用于静态部署）
const useHashRouter = import.meta.env.VITE_USE_HASH_ROUTER === 'true' || 
                      window.location.pathname.includes('index.html') ||
                      !window.history.pushState;

const Router = useHashRouter ? HashRouter : BrowserRouter;

function AppContent() {
  return (
    <>
      <GhibliBackground />
      <div
        className="min-h-screen"
        style={{
          backgroundColor: "oklch(0.97 0.015 70 / 0.80)",
          backdropFilter: "blur(1px)",
        }}
      >
        <Navbar />
        <AnimatedRoutes>
          <Route path="/" data-genie-title="首页" data-genie-key="Home" element={<PageTransition transition="fade"><Home /></PageTransition>} />
          <Route path="/map" data-genie-title="旅行地图" data-genie-key="Map" element={<PageTransition transition="slide-fade"><MapPage /></PageTransition>} />
          <Route path="/timeline" data-genie-title="时光相册" data-genie-key="Timeline" element={<PageTransition transition="slide-up"><TimelinePage /></PageTransition>} />
          <Route path="/photos" data-genie-title="照片管理" data-genie-key="Photos" element={<PageTransition transition="slide-up"><PhotosPage /></PageTransition>} />
          <Route path="/about" data-genie-title="关于我们" data-genie-key="About" element={<PageTransition transition="scale"><AboutPage /></PageTransition>} />
          <Route path="*" data-genie-key="NotFound" data-genie-title="页面未找到" element={<PageTransition transition="fade"><NotFound /></PageTransition>} />
        </AnimatedRoutes>
        <MusicPlayer />
      </div>
    </>
  );
}

function App() {
  return (
    <TooltipProvider>
      <Toaster />
      <Router>
        <PasswordGate>
          <AppContent />
        </PasswordGate>
      </Router>
    </TooltipProvider>
  );
}

export default App